import forEach from 'utils/DOM/forEach'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import applyRules from './applyRules'
import store from 'utils/store/withMiddleware'
import saveToStorage from 'core/controllerPlans/saveToStorage'
import { AMERITAS_DENTAL, DENTAL } from 'core/constants/products'

function handleAddons(state, selectedPlanId) {
  const addonsByPlan = state.addonsByPlan[selectedPlanId]

  forEach('.addon__input', node => {
    const [planId, addonId] = node.dataset.ids.split('-')
    if (+planId === selectedPlanId) {
      const isSelected = addonsByPlan.includes(+addonId)
      node.checked = isSelected
      toggleClass(`#addon-${planId}-${addonId}`, 'active', isSelected)

      const productId = state.plans[addonId].productId
      const isDental = productId === DENTAL || productId === AMERITAS_DENTAL
      node.dataset.spValue = `${isSelected ? 'add' : 'remove'} ${
        isDental ? 'dental' : 'latitude'
      } ${addonId}`
    }
  })

  const newState = applyRules(state)
  saveToStorage(newState)
  store.update(newState, true)

  textContent(`#value-${selectedPlanId}`, newState.plans[selectedPlanId].cost)
  textContent(`#planName-${selectedPlanId}`, newState.plans[selectedPlanId].title)
}

export default handleAddons
